import { Injectable } from "@angular/core";
import {
  distinctUntilChanged,
  fromEvent,
  map,
  merge,
  of,
  startWith,
} from "rxjs";

@Injectable({
  providedIn: "root",
})
export class WindowHelperService {
  static prevWidth = null;
  constructor() {}

  static newSizeObserver(callback: () => any) {
    return new ResizeObserver((entries) => {
      for (const entry of entries) {
        const width = entry.borderBoxSize?.[0].inlineSize;
        if (typeof width === "number" && width !== this.prevWidth) {
          callback();
        }
      }
    });
  }

  static getWindowWidth() {
    return merge(
      of(window.innerWidth),
      fromEvent(window, "resize").pipe(map(() => window.innerWidth)),
    ).pipe(startWith(window.innerWidth), distinctUntilChanged());
  }

  static isMobile() {
    return this.getWindowWidth().pipe(map((width) => width < 840));
  }

  static isUwide() {
    return this.getWindowWidth().pipe(map((width) => width > 1920));
  }

  static isLd() {
    return this.getWindowWidth().pipe(map((width) => width < 1024));
  }

  static isMd() {
    return this.getWindowWidth().pipe(map((width) => width < 1280));
  }
}
